module.exports = __webpack_public_path__ + "static/img/community21.5440cf1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/community21.png
// module id = cQkN
// module chunks = 0